import classNames from 'classnames';

import SVG from '../SVG/SVG';

import toggleIcon from './graphics/toggle.svg?raw';

import styles from './ToggleIcon.module.css';

type ToggleIconProps = {
    toggled: boolean;
    disabled?: boolean;
    defaultOrientation?: 'down' | 'right';
};

const ToggleIcon = ({
    toggled,
    disabled,
    defaultOrientation = 'right',
}: ToggleIconProps) => {
    return (
        <SVG
            src={toggleIcon}
            className={classNames(styles.Root, {
                [styles.right]: defaultOrientation === 'right',
                [styles.down]: defaultOrientation === 'down',
                [styles.toggled]: toggled,
                [styles.hidden]: disabled,
            })}
        />
    );
};

export default ToggleIcon;
